export default {
  mounted() {
    this.el.addEventListener("keydown", (e) => {
      if (!e.shiftKey && e.key === 'Enter') {
        const inputValue = this.el.value.trim();

        if (inputValue === "") {
          e.preventDefault();
          return;
        }

        this.el.form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        );

        this.el.value = '';
      }
    })
  }
}